import classNames from 'classnames'
import React from 'react'
import { SvgMaster, SvgGold, SvgSilver, SvgBronze} from './assets';

const rankAssets = [SvgMaster, SvgGold, SvgSilver, SvgBronze];


function Rank({ rank }) {
  if (rank > 3)
    return <span>{rank}</span>;
  return <img src={rankAssets[rank]} alt="rank" />
}


export default function ResultInternal({ result, currentEmail }) {
  return result && (
    <div className="result" id="result">
    <table>
      <tbody>
        {
          result.map(({ user, organization, load, email, jobTitle, rank }, index) => (
            <tr key={index} className={classNames({
              current: index === result.length - 1 && email === currentEmail,
              first: index === 0,
            })}>
              <td className="rank"><Rank rank={rank || index} /></td>
              <td className="name">
                <div>
                  <span>{organization}</span><span>{user}</span>
                </div>
              </td>
              <td className="jobtitle">{jobTitle}</td>
              <td>{load.toFixed(1)}%</td>
            </tr>
          ))
        }
      </tbody>
    </table>
  </div>
  )
}
